
/**
 * 링크 유형 (외부 링크 또는 프로젝트 링크)
 */
export type ExploreContentItemContentOneOfFivezeroMediaLinksItemLinkType = typeof ExploreContentItemContentOneOfFivezeroMediaLinksItemLinkType[keyof typeof ExploreContentItemContentOneOfFivezeroMediaLinksItemLinkType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExploreContentItemContentOneOfFivezeroMediaLinksItemLinkType = {
  EXTERNAL: 'EXTERNAL',
  PROJECT: 'PROJECT',
} as const;
